import { stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const WorkingHoursSchema = object().shape({

    monday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    tuesday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    wednesday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    thursday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    friday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    saturday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    }),
    sunday: object().shape({
        timings: array().of(object().shape({
            start_time: stringOptionalSchema,
            end_time: string().when("start_time", {
                is: (start_time) => !!start_time,
                then: () => stringRequiredSchema,
                otherwise: () => stringOptionalSchema,
            }),
        })),
    })
});

export default WorkingHoursSchema;